import React from 'react';
import {useAtom} from "jotai";
import {modalState} from "../../../states/action";


/**
 과거 기록 가져오기

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function HeaderHistory() {

  const [{modalOn}, setModalOn] = useAtom(modalState);

  return (
    <>
      <button
        type="button"
        className="btn_history"
        onClick={() => {
          setModalOn({
            modalOn:modalOn ? modalOn : !modalOn,
            modalTitle: '자막 불러오기',
            modalContentName:'ModalCaptionHistory'
          })
        }}
      >
        이전 자막 불러오기
      </button>
    </>
  );
}
